import React from 'react';
import { Link } from 'react-router-dom';

const PlatformFooter = () => (
  <footer className="platform-footer">
    <Link to="/" className="platform-footer__brand" aria-label="Civic Intelligence Platform home">
      <img src="/cip.png" alt="Civic Intelligence Platform" className="platform-footer__logo" />
      <span>Civic Intelligence Platform</span>
    </Link>
  </footer>
);

export default PlatformFooter;
